import { createSlice } from "@reduxjs/toolkit"

export const processToCheckoutSlice = createSlice({
	name: "process_to_checkout",
	initialState: {
		checkout_cart: "",
		errors: [],
	},

	reducers: {
		setCheckoutCart: (state, action) => {
			state.checkout_cart = action.payload
		},
		setCheckoutCartSuccess: (state, action) => {
			state.checkout_cart = action.payload
		},
		
		getErrors: (state, action) => {
			state.errors = action.payload
			// console.log(action.payload, "reducer")
		},
	},
})

// Action creators are generated for each case reducer function
export const {setCheckoutCart, setCheckoutCartSuccess, getErrors} = processToCheckoutSlice.actions

export default processToCheckoutSlice.reducer
